
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {amountConversion, DataConversion} from "../../utils/util";
export default {
name: "TuanCustomDetail",
directives: {
TransferDom
},
components: {
Cell,
Group,
XButton,
XInput,
XDialog,
CellFormPreview,
Flexbox,
FlexboxItem
},
data(){
return {
dialogMsg: '',
showHideOnBlur:false,
shopId: this.$route.params.shopId,
orderNo: this.$route.params.orderNo,
orderData: {},
customTypeMap: new Map([[1, "年会"], [2, "团建"], [3, "聚会"], [4, "培训"], [5, "其他"],
[31, "参观"], [32, "参观+讲解"], [33, "红色剧本体验"],
[61, "塔熊"], [62, "雄塔"]]),
orderStatusMap: new Map([[0,"已取消"], [1,"提交(待确认)"], [2,"已确认"], [3,"已完成"], [100,"删除"]]),
operatorMap: new Map([[2,"庞志雄"], [3,"高稳塔"], [23,"陈冠兴"]]),
confirmText: "确认",
confirmDisabled: false,
confirmRemark: "",
completeText: "完成",
completeDisabled: false,
completeRemark: "",
bankRecordCode: "",

showContent002: false,
fiList: [{
label: '合同金额：25000.00',
value: '预计成本：20000.00'
},{
label: '请款记录：',
value: ''
},{
label: '1. 2023-12-12 12:12:12【已审核】',
value: '10000.00元'
}, {
label: '2. 2023-12-12 12:12:12【已支付】',
value: '20000.00元'
}, {
label: '3. 2023-12-12 12:12:12【审核不通过】',
value: '30000.00元'
}, {
label: '',
value: '----------------------------'
}, {
label: '',
value: '已支出金额：18000.00'
}],

orderTypeName: "团建需求",
orderType: 1,        //1:塔熊团建（及其他）；3:陆河预约；6:塔熊财务
managerList: [],     //店铺管理员
confirmOperatorName: '',        //审核员
consumeOperatorName: ''         
}
},
created(){
document.title = this.orderTypeName;
this.initPageData();
},
methods:{
initPageData(){
this.getCustomList();
},
getCustomList(){
let _this = this;
let shopId = _this.shopId
_this.axios.post('/v1/shop/'+shopId+'/custom/tuan/GET_CUSTOMIZE_ORDER_LIST', {
orderNo: _this.orderNo
}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

let {total: resTotal, rows: resRow} = response.data.data;

if (Array.isArray(resRow) && resRow.length > 0) {
let firstArr, otherArr;
[firstArr, ...otherArr] = resRow;
_this.orderData = firstArr;
if(30<=_this.orderData.type && _this.orderData.type<40) {
_this.orderType = 3;
_this.orderTypeName = "参观预约";
} else if (60<=_this.orderData.type && _this.orderData.type<70) {
_this.orderType = 6;
_this.orderTypeName = "塔熊财务--请款单";
_this.queryOperatorList();
_this.getProjectInfo(_this.orderData.destination);
} else {
_this.orderType = 1;
_this.orderTypeName = "团建需求";
}
document.title = _this.orderTypeName;
}
}
}).catch(function (response) {
console.log(response);
});
},

getMapValue:DataConversion.getMapValueByKey,

processButtonConfirm(){
this.confirmText = "确认数据提交中...";
this.confirmDisabled = true;

let _this = this;
let shopId = _this.shopId
_this.axios.post('/v1/shop/'+shopId+'/custom/tuan/CONFIRM_CUSTOMIZE_ORDER', {
orderNo: _this.orderNo,
remark: _this.confirmRemark,
}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
}
}).catch(function (response) {
_this.dialogMsg = '失败了，请刷新后重试'
_this.showHideOnBlur = true
});
},

processButtonComplete(){
this.completeText = "完成数据提交中...";
this.completeDisabled = true;

let _this = this;
let shopId = _this.shopId
_this.axios.post('/v1/shop/'+shopId+'/custom/tuan/CONSUME_CUSTOMIZE_ORDER', {
orderNo: _this.orderNo,
remark: _this.completeRemark,
}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
}
}).catch(function (response) {
_this.dialogMsg = '失败了，请刷新后重试'
_this.showHideOnBlur = true
});
},



queryOperatorList()
{
let _this = this;
let shopId = this.$route.params.shopId
let uri = '/v1/shop/'+ shopId +'/manage/operator/list';
_this.axios.get(uri, null, {
headers: {}
}).then(function (response) {
_this.managerList = response.data.data;
for(var i=0; i<_this.managerList.length; i++) {
if (_this.managerList[i].id == _this.orderData.confirmOperatorId) {
_this.confirmOperatorName = _this.managerList[i].real_name;
}
if (_this.managerList[i].id == _this.orderData.consumeOperatorId) {
_this.consumeOperatorName = _this.managerList[i].real_name;
}
}
}).catch(function (response) {
console.log(response);

});
},

financialAudit(pass){
this.confirmText = "数据提交中...";
this.confirmDisabled = true;

let _this = this;
let shopId = _this.shopId;
_this.axios.post('/v1/shop/'+shopId+'/custom/finance/audit', {
orderId: _this.orderData.id,
remark: _this.confirmRemark,
auditPass: pass
}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg;
_this.showHideOnBlur = true
}
}).catch(function (response) {
_this.dialogMsg = '失败了，请刷新后重试'
_this.showHideOnBlur = true
});
},

financialExe(){
let _this = this;
debugger;
if (!_this.bankRecordCode) {
_this.dialogMsg = '银行流水号不能为空！';
_this.showHideOnBlur = true;
return;
}

this.confirmText = "数据提交中...";
this.confirmDisabled = true;

let shopId = _this.shopId;
_this.axios.post('/v1/shop/'+shopId+'/custom/finance/exe', {
orderId: _this.orderData.id,
bankRc: _this.bankRecordCode
}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg;
_this.showHideOnBlur = true
}
}).catch(function (response) {
_this.dialogMsg = '失败了，请刷新后重试'
_this.showHideOnBlur = true
});
},
setProjectInfo(prjInfo)
{
let _this = this;
let payOut = prjInfo.pay_out_plan;
if(payOut==undefined){
payOut = 0;
}
let itemList = [{
label: '合同金额：' + (parseInt(prjInfo.contract_amount)/100),
value: '预计成本：' + (parseInt(payOut)/100)
},{
label: '请款记录：',
value: ''
}];

let items = prjInfo.finance_order;
for ( var i=0; i<items.length; i++ ) {
let item = {};
let statusText = items[i].status=='2'?"已审核":(items[i].status=='3'?"已完成":"未知");
item.label = ''+(i+1)+'. '+items[i].created_at+' 【'+statusText+'】';
item.value = parseInt(items[i].amount)/100;
itemList.push(item);
}

let item = {
label: '',
value: '已支出金额：' + (parseInt(prjInfo.total)/100)
};
itemList.push(item);
_this.fiList = itemList;
_this.$set(_this.fiList, itemList);
},
getProjectInfo(projectString)
{
let _this = this;
let shopId = this.$route.params.shopId;
if (projectString==null || projectString=='') {
_this.dialogMsg = '项目参数异常';
_this.showHideOnBlur = true;
return;
}
let prj = projectString.split("|");
if (prj.length<2) {
_this.dialogMsg = '项目参数异常';
_this.showHideOnBlur = true;
return;
}
let projectId = prj[0];
let uri = '/v1/shop/'+ shopId +'/custom/finance/project?projectId='+projectId;
_this.axios.get(uri, null, {
headers: {}
}).then(function (response) {
let prjInfo = response.data.data;
_this.setProjectInfo(prjInfo)
}).catch(function (response) {
console.log(response);

});
},
penny2yuan:amountConversion.penny2yuan
}
}



// WEBPACK FOOTER //
// ./src/components/tuan/TuanCustomDetail.vue